import "src/decidim/initiatives/check_code";
import "src/decidim/initiatives/scoped_type";
